import { render, staticRenderFns } from "./ParticipantIdentification.vue?vue&type=template&id=0ba1ad47&scoped=true"
import script from "./ParticipantIdentification.ts?vue&type=script&lang=ts&external"
export * from "./ParticipantIdentification.ts?vue&type=script&lang=ts&external"
import style0 from "./ParticipantIdentification.scss?vue&type=style&index=0&id=0ba1ad47&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba1ad47",
  null
  
)

export default component.exports